import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import Calculator from "@/pages/Calculator";
import Proposals from "@/pages/Proposals";
import CRM from "@/pages/CRM";
import Projects from "@/pages/Projects";
import Finance from "@/pages/Finance";
import AnaliseComparativa from "@/pages/AnaliseComparativa";
import Scripts from "@/pages/Scripts";
import PublicProposal from "@/pages/PublicProposal";
import AdminPanel from "@/pages/AdminPanel";
import Team from "@/pages/Team";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import CompanySettings from "@/pages/CompanySettings";


function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center font-serif text-2xl">Carregando…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function ManagerRoute({ children }) {
  const { user } = useAuth();
  if (user?.role === "revisor") return <Navigate to="/app/projetos" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/cadastro" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/p/:id" element={<PublicProposal />} />

      <Route path="/app/checkout" element={<Protected><Checkout /></Protected>} />
      <Route path="/app/payment-success" element={<Protected><PaymentSuccess /></Protected>} />

      <Route path="/app" element={<Protected><AppLayout /></Protected>}>
        <Route index element={<ManagerRoute><Navigate to="dashboard" replace /></ManagerRoute>} />
        <Route path="dashboard" element={<ManagerRoute><Dashboard /></ManagerRoute>} />
        <Route path="calculadora" element={<ManagerRoute><Calculator /></ManagerRoute>} />
        <Route path="propostas" element={<ManagerRoute><Proposals /></ManagerRoute>} />
        <Route path="crm" element={<ManagerRoute><CRM /></ManagerRoute>} />
        <Route path="projetos" element={<Projects />} />
        <Route path="financeiro" element={<ManagerRoute><Finance /></ManagerRoute>} />
        <Route path="analise-comparativa" element={<ManagerRoute><AnaliseComparativa /></ManagerRoute>} />
        <Route path="scripts" element={<ManagerRoute><Scripts /></ManagerRoute>} />
        <Route path="equipe" element={<ManagerRoute><Team /></ManagerRoute>} />
        <Route path="configuracoes" element={<ManagerRoute><CompanySettings /></ManagerRoute>} />
        <Route path="admin" element={<AdminPanel />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;

